export const tr = {
    lang: 'tr',
    highFrequency: [
        've',
        'bir',
        'bu',
        'da',
        'de',
        'için',
        'ile',
        'ki',
        'ne',
        'o',
        'çok',
        'gibi',
        'daha',
        'ama',
        'ben',
        'sen',
        'biz',
        'siz',
        'şu',
        'her',
        'en',
        'mi',
        'mı',
        'mu',
        'mü',
        'ya',
        'ise',
        'ancak',
        'artık',
        'bile',
        'böyle',
        'öyle',
        'sonra',
        'önce',
        'kadar',
        'göre',
        'diye',
        'hem',
        'hiç',
        'yine',
        'işte',
        'evet',
        'var',
        'yok',
        'olan',
        'olarak',
        'çünkü',
        'eğer',
        'fakat',
        'veya',
        'yani',
        'zaten',
        'şimdi',
        'nasıl',
        'neden',
        'kim',
        'hangi',
        'kaç',
        'bütün',
        'tüm',
        'bazı',
        'başka',
        'diğer',
        'aynı',
        'iki',
        'üç',
        'ilk',
        'son',
        'iyi',
        'kötü',
        'büyük',
        'küçük',
        'yeni',
        'şey',
        'hep',
        'pek',
        'az',
        'tek',
        'bana',
        'sana',
        'ona',
        'beni',
        'seni',
        'onu',
        'bunu',
        'şunu',
        'bizi',
        'sizi',
    ],
    stickForward: [
        've',
        'veya',
        'ile',
        'ki',
        'bir',
        'bu',
        'şu',
        'o',
        'her',
        'en',
        'daha',
        'ama',
        'fakat',
        'çünkü',
        'eğer',
        'hem',
        'ya',
        'hiç',
    ],
    stickBackward: [
        'ile',
        'için',
        'gibi',
        'kadar',
        'göre',
        'da',
        'de',
        'ki',
        'mi',
        'mı',
        'mu',
        'mü',
        'ise',
        'diye',
    ],
    highFreqGateClusters: null,
};
//# sourceMappingURL=tr.js.map